
import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

export interface DialogData {
    salutation: string;
    firstname: string;
    lastname: string;
    tel: string;
  }

@Component({
    selector: 'app-offerpackform',
    templateUrl: './offerpackform.component.html',
    styleUrls: ['./offerpackform.component.scss'],
    standalone: false
})
export class OfferpackformComponent implements OnInit {
    data: DialogData;
    constructor (
        public dialogRef: MatDialogRef<OfferpackformComponent>
    ) { }

    ngOnInit (): void {
        this.data = {
            salutation: '',
            firstname: '',
            lastname: '',
            tel: ''
        }
    }

    onNoClick (): void {
        this.dialogRef.close();
    }

    async salutationChange (ev) {
        this.data.salutation = ev.value;
    }
}
